const translations = {
  "Weekly Metrics": "Indicateurs Hebdomadaires",
  "Total initial capital": "Capital initial total",
  "Initial capital": "Capital initial",
  "Week": "Semaine",
  "Profit": "Profit",
  "Net Profit": "Profit Net",
  "Return on Initial Equity": "Retour sur Capital Initial",
  "Return on Total Equity": "Retour sur Capital Total",
  "Trades": "Transactions",
  "Profit Factor": "Facteur de Profit",
  "Percent Profitable Trades": "Pourcentage Transactions Rentable",
  "TradeList": "Liste des Transactions",
  "Search": "Recherche",
  "Source": "Source",
  "Type": "Type",
  "Date": "Date",
  "Price": "Prix",
  "Quantity": "Quantité",
  "Cumulative Profit": "Profit Cumulé",
  "Cumulative Profit %": "Profit Cumulé %",
  "Settings": "Paramètres",
  "Show file info on import page": "Afficher les informations sur les fichiers sur la page d'importation",
  "Dark Mode": "Mode Sombre",
  "Show Currency Symbol": "Afficher le Symbole de la Monnaie",
  "Currency Symbol": "Symbole de la Monnaie",
  "Language": "Langue",
  "Monthly Metrics": "Indicateurs Mensuels",
  "Month": "Mois",
  "Import Data": "Importer des Données",
  "Drag & drop some files here, or click to select files": "Glissez et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers",
  "Show file infos": "Afficher les informations sur les fichiers",
  "Include All": "Tout inclure",
  "Include None": "Ne rien inclure",
  "Remove All": "Tout supprimer",
  "Include": "Inclure",
  "Name": "Nom",
  "File Name": "Nom du fichier",
  "Lines": "Lignes",
  "Initial Equity": "Capital Initial",
  "Recalculated Initial Equity": "Capital Initial Recalculé",
  "No files uploaded yet.": "Aucun fichier téléchargé pour le moment.",
  "Confirm Deletion": "Confirmer la Suppression",
  "Are you sure you want to delete": "Êtes-vous sûr de vouloir supprimer",
  "the file named": "le fichier nommé",
  "all files": "tous les fichiers",
  "Cancel": "Annuler",
  "Confirm": "Confirmer",
  "Dashboard": "Dashboard",
  "Reports": "Rapports",
  "Analytics": "Analyses",
  "Logout": "Déconnexion",
  "Main": "Principal",
  "Instructions": "Instructions",
  "Imports": "Importations",
  "Metrics": "Indicateurs",
  "Periodical Returns": "Rendements Périodiques",
  "Annual": "Annuel",
  "Monthly": "Mensuel",
  "Weekly": "Hebdomadaire",
  "Daily": "Quotidien",
  "Visuals": "Visuels",
  "Equity Graphs": "Graphiques de Capitaux",
  "Drawdown Graphs": "Graphiques de Drawdown",
  "Others": "Autres",
  "Disclaimer": "Avertissement",
  "Metric": "Métrique",
  "Value": "Valeur",
  "Initial Capital": "Capital Initial",
  "Total Net Profit": "Profit Net Total",
  "Gross Profit": "Profit Brut",
  "Gross Loss": "Perte Brute",
  "Pessimistic RR": "RR Pessimiste",
  "Total Trades": "Total des Transactions",
  "Winning Trades": "Transactions Gagnantes",
  "Losing Trades": "Transactions Perdantes",
  "Avg Trade Net Profit": "Profit Net Moyen par Transaction",
  "Avg Winning Trade": "Transaction Gagnante Moyenne",
  "Avg Losing Trade": "Transaction Perdante Moyenne",
  "Largest Win": "Plus Grande Victoire",
  "Max Cons Winners": "Max Cons Gagnants",
  "Largest Loss": "Plus Grande Perte",
  "Max Cons Losers": "Max Cons Perdants",
  "Trading Period": "Période de Trading",
  "Total Trading Days": "Total des Jours de Trading",
  "Longest Flat Period Days": "Période Plate la Plus Longue",
  "Max Drawdown": "Max Drawdown",
  "Max Drawdown As % Of Initial Equity": "Max Drawdown en % du Capital Initial",
  "Max Drawdown As % Of Total Equity": "Max Drawdown en % du Capital Total",
  "Max Drawdown Date": "Date du Max Drawdown",
  "Max Intraday Drawdown": "Max Drawdown Intrajournalier",
  "Max Intraday Drawdown As % Of Initial Equity": "Max Drawdown Intrajournalier en % du Capital Initial",
  "Max Intraday Drawdown As % Of Total Equity": "Max Drawdown Intrajournalier en % du Capital Total",
  "Max Intraday Drawdown Date": "Date du Max Drawdown Intrajournalier",
  "Longest Drawdown Days": "Jours de Drawdown les Plus Longs",
  "Recovery Factor": "Facteur de Récupération",
  "NP Max DD": "NP Max DD",
  "NP Intraday Max DD": "NP Max DD Intrajournalier",
  "Avg Worst 5 DD": "Moyenne des 5 Pires DD",
  "Avg Worst 5 DD As % Of Initial Equity": "Moyenne des 5 Pires DD en % du Capital Initial",
  "Max Runup": "Max Runup",
  "Max Runup As % Of Initial Equity": "Max Runup en % du Capital Initial",
  "Max Runup As % Of Total Equity": "Max Runup en % du Capital Total",
  "Max Runup Date": "Date du Max Runup",
  "Longest Runup Days": "Jours de Runup les Plus Longs",
  "Margin Requirements": "Exigences de Marge",
  "Return on Initial Capital": "Retour sur Capital Initial",
  "Annual Rate of Return": "Taux de Retour Annuel",
  "Avg Monthly Return": "Retour Mensuel Moyen",
  "Std Dev Monthly Return": "Écart Type du Retour Mensuel",
  "Percent Profitable Months": "Pourcentage de Mois Rentables",
  "Sharpe Ratio": "Ratio de Sharpe",
  "Sortino Ratio": "Ratio de Sortino",
  "Sterling Ratio": "Ratio de Sterling",
  "MAR Ratio": "Ratio de MAR",
  "Efficiency Factor": "Facteur d'Efficacité",
  "Max Intraday Runup": "Max Runup Intrajournalier",
  "Max Intraday Runup Date": "Date du Max Runup Intrajournalier",
  "Max Intraday Runup Duration": "Durée du Max Runup Intrajournalier",
  "How to Import Your Trading Data:": "Comment importer vos données de trading :",
  "Note: There are still calculation bugs. Please use with care.": "Remarque : Il y a encore des bugs de calcul. Veuillez utiliser avec précaution.",
  "Step 1:": "Étape 1 :",
  "Export CSV Files from TradingView:": "Exporter des fichiers CSV depuis TradingView :",
  "Open the tab as shown in the image above.": "Ouvrez l'onglet comme indiqué sur l'image ci-dessus.",
  "Click the Download button (also highlighted in the image) to export your trading list as CSV files.": "Cliquez sur le bouton Télécharger (également mis en évidence sur l'image) pour exporter votre liste de trading au format CSV.",
  "Step 2:": "Étape 2 :",
  "Upload CSV Files to the Application:": "Télécharger des fichiers CSV dans l'application :",
  'Navigate to the "Manage Data" page from the menu.': 'Naviguez vers la page "Gérer les données" dans le menu.',
  "Upload the exported CSV files.": "Téléchargez les fichiers CSV exportés.",
  "Step 3:": "Étape 3 :",
  "Manage Uploaded Files:": "Gérer les fichiers téléchargés :",
  "Each uploaded file can be included in calculations by selecting it.": "Chaque fichier téléchargé peut être inclus dans les calculs en le sélectionnant.",
  "You can assign a custom name to each file for better identification.": "Vous pouvez attribuer un nom personnalisé à chaque fichier pour une meilleure identification.",
  "Step 4:": "Étape 4 :",
  "Initial Equity Adjustment:": "Ajustement du capital initial :",
  "The initial amount of equity is estimated by reverse-calculating from your trading data. However, this may not always produce accurate results.": "Le montant initial du capital est estimé en recalculant à partir de vos données de trading. Cependant, cela peut ne pas toujours produire des résultats précis.",
  "After uploading each file, you can manually edit and input the correct initial equity if needed.": "Après avoir téléchargé chaque fichier, vous pouvez manuellement éditer et saisir le capital initial correct si nécessaire.",
  "Follow these steps to ensure accurate calculations and proper management of your trading data.": "Suivez ces étapes pour garantir des calculs précis et une gestion appropriée de vos données de trading.",
  "Loading the magic": "Chargement de la magie",
  "Summoning the data wizards": "Invocation des sorciers des données",
  "Hold tight, data incoming": "Tenez bon, les données arrivent",
  "Just a moment, making things awesome": "Un instant, nous rendons les choses géniales",
  "Data elves are at work": "Les elfes des données sont au travail",
  "Brewing some data potions": "Préparation de potions de données",
  "Hang on, crunching numbers": "Attendez, nous triturons les chiffres",
  "Data is on its way": "Les données sont en route",
  "Almost there, stay tuned": "Presque là, restez à l'écoute",
  "Fetching unicorns": "Récupération des licornes",
  "Aligning the stars": "Alignement des étoiles",
  "Polishing the data crystals": "Polissage des cristaux de données",
  "Warming up the servers": "Réchauffement des serveurs",
  "Gathering the bytes": "Collecte des octets",
  "Charging the flux capacitor": "Chargement du condensateur de flux",
  "Calibrating the data matrix": "Calibrage de la matrice de données",
  "Spinning up the hamster wheels": "Mise en route des roues de hamster",
  "Consulting the oracles": "Consultation des oracles",
  "Synchronizing the clocks": "Synchronisation des horloges",
  "Yearly Metrics": "Indicateurs Annuels",
  "Daily Metrics": "Indicateurs Quotidiens",
  "January": "Janvier",
  "February": "Février",
  "March": "Mars",
  "April": "Avril",
  "May": "Mai",
  "June": "Juin",
  "July": "Juillet",
  "August": "Août",
  "September": "Septembre",
  "October": "Octobre",
  "November": "Novembre",
  "December": "Décembre",
  "Trading Metrics": "Indicateurs de Trading",
  "Loading...": "Chargement...",
  "Config": "Configuration",
  "Config File Name": "Nom du fichier de configuration",
  "No config file": "Pas de fichier de configuration",
  "Config File Content": "Contenu du fichier de configuration",
  "Confirm Config Deletion": "Confirmer la suppression de la configuration",
  "Are you sure you want to delete the config file for": "Êtes-vous sûr de vouloir supprimer le fichier de configuration pour",
  "Close": "Fermer",
  "tradingRange": "Plage de Trading",
  "backtestingRange": "Plage de Backtesting",
  "symbol": "Symbole",
  "timeframe": "Intervalle de Temps",
  "chartType": "Type de Graphique",
  "pointValue": "Valeur du Point",
  "currency": "Devise",
  "tickSize": "Taille du Tick",
  "precision": "Précision",
  "initialCapital": "Capital Initial",
  "orderSize": "Taille de l'Ordre",
  "pyramiding": "Pyramiding",
  "commission": "Commission",
  "slippage": "Slippage",
  "verifyPriceForLimitOrders": "Vérifier le Prix pour les Ordres Limites",
  "marginForLongPositions": "Marge pour les Positions Longues",
  "marginForShortPositions": "Marge pour les Positions Courtes",
  "recalculateAfterOrderIsFilled": "Recalculer Après Remplissage de l'Ordre",
  "recalculateOnEveryTick": "Recalculer à Chaque Tick",
  "recalculateOnBarClose": "Recalculer à la Clôture de la Barre",
  "backtestingPrecisionUseBarMagnifier": "Précision du Backtesting Utiliser Loupe de Barre",
  "Expert Mode": "Mode Expert",
  "totalNetProfit": "Profit Net Total",
  "grossProfit": "Profit Brut",
  "grossLoss": "Perte Brute",
  "profitFactor": "Facteur de Profit",
  "totalTrades": "Total des Transactions",
  "winningTradesCount": "Transactions Gagnantes",
  "losingTradesCount": "Transactions Perdantes",
  "percentProfitable": "Pourcentage Transactions Rentable",
  "avgTradeNetProfit": "Profit Net Moyen par Transaction",
  "avgWinningTrade": "Transaction Gagnante Moyenne",
  "avgLosingTrade": "Transaction Perdante Moyenne",
  "largestWin": "Plus Grande Victoire",
  "largestLoss": "Plus Grande Perte",
  "maxDrawdown": "Max Drawdown",
  "maxDrawdownDate": "Date du Max Drawdown",
  "annualRateOfReturn": "Taux de Retour Annuel",
  "sharpeRatio": "Ratio de Sharpe",
  "sortinoRatio": "Ratio de Sortino",
  "sterlingRatio": "Ratio de Sterling",
  "marRatio": "Ratio de MAR",
  "efficiencyFactor": "Facteur d'Efficacité",
  "returnOnInitialCapital": "Retour sur Capital Initial",
  "marginRequirements": "Exigences de Marge",
  "maxDrawdownAsPercentOfInitialEquity": "Max Drawdown en % du Capital Initial",
  "maxDrawdownAsPercentOfTotalEquity": "Max Drawdown en % du Capital Total",
  "maxIntradayDrawdownAsPercentOfInitialEquity": "Max Drawdown Intrajournalier en % du Capital Initial",
  "maxIntradayDrawdownAsPercentOfTotalEquity": "Max Drawdown Intrajournalier en % du Capital Total",
  "recoveryFactor": "Facteur de Récupération",
  "npMaxDD": "NP Max DD",
  "npIntradayMaxDD": "NP Max DD Intrajournalier",
  "avgWorst5DD": "Moyenne des 5 Pires DD",
  "maxRunupAsPercentOfInitialEquity": "Max Runup en % du Capital Initial",
  "maxRunupAsPercentOfTotalEquity": "Max Runup en % du Capital Total",
  "maxIntradayRunupAsPercentOfInitialEquity": "Max Runup Intrajournalier en % du Capital Initial",
  "maxIntradayRunupAsPercentOfTotalEquity": "Max Runup Intrajournalier en % du Capital Total",
  "maxIntradayRunupDuration": "Durée du Max Runup Intrajournalier",
  "maxIntradayRunup": "Max Runup Intrajournalier",
  "maxIntradayRunupDate": "Date du Max Runup Intrajournalier",
  "Select Metrics": "Sélectionner les Indicateurs",
  "Additional Expert Mode Metrics": "Indicateurs Supplémentaires en Mode Expert",
  "Select All": "Tout sélectionner",
  "Deselect All": "Tout désélectionner",
  "Open Metrics Popup": "Ouvrir la fenêtre des métriques",
  "View and Select Metrics": "Voir et sélectionner les métriques",
  "Show Advanced Metrics": "Afficher les Indicateurs Avancés",
  "Monthly Profit and Loss": "Profit et Perte Mensuels",
  "Monthly Graphs": "Graphiques Mensuels",
  "Profits and Losses": "Profits et Pertes",
  "(Optional) How to Import And Remember Your Backtest Configuration:": "Optionnel : Comment importer et mémoriser votre configuration de backtest :",
  "Export Configuration:": "Exporter la Configuration :",
  "Navigate to the 'Configuration' page in the TradingView backtester.": "Naviguez vers la page 'Configuration' dans le backtester de TradingView.",
  "Click the 'Export' button to save your current configuration.": "Cliquez sur le bouton 'Exporter' pour enregistrer votre configuration actuelle.",
  "Import Configuration:": "Importer la Configuration :",
  "Click the 'Import' button in the config column of your entries row and upload the exported csv file.": "Cliquez sur le bouton 'Importer' dans la colonne de configuration de votre ligne d'entrées et téléchargez le fichier csv exporté.",
  "Manage Configuration:": "Gérer la Configuration :",
  "You can view your configuration again as needed by clicking on the eye icon.": "Vous pouvez revoir votre configuration si nécessaire en cliquant sur l'icône en forme d'œil.",
  "Open the tab 'List of Trades' in the TradingView backtester as shown in the image above.": "Ouvrez l'onglet 'Liste des Transactions' dans le backtester de TradingView comme indiqué sur l'image ci-dessus.",
  "Use deep backtest": "Utiliser le deep backtest",
  "Start Date": "Date de début",
  "End Date": "Date de fin",
  "Active dataset": "Jeu de données actif",
  "Manage Datasets": "Gérer les jeux de données",
  "Number of Files": "Nombre de Fichiers",
  "First Trade": "Première Transaction",
  "Last Trade": "Dernière Transaction",
  "All files": "Tous les fichiers",
  "Included files": "Fichiers inclus",
  "Number of Trades": "Nombre de transactions",
  "Confirm Dataset Deletion": "Confirmer la suppression du jeu de données",
  "Are you sure you want to delete the dataset named": "Êtes-vous sûr de vouloir supprimer le jeu de données nommé",
  "Add New Dataset": "Ajouter un nouveau jeu de données",
  "Dataset Name": "Nom du jeu de données",
  "Add": "Ajouter",
  "Manage Data": "Gérer les données",
  "Confirm Initial Capital": "Confirmer le capital initial",
  "Initial Capital from Config": "Capital initial de la configuration",
  "Add Dataset": "Ajouter un jeu de données",
  "Total Wins": "Total des Victoires",
  "Total Losses": "Total des Pertes",
  "Timestamp": "Horodatage",
  "days": "jours",
};

// Reminder: Don't forget to translate the MUI X filter phrases.
export default translations;